export default {"src":"/_next/static/media/Virpp-logo-svg.dc1bc101.svg","height":47,"width":192,"blurWidth":0,"blurHeight":0};